import React from 'react';
import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';
import DiamondBalanceAtom from '../../../recoil/cashout/DiamondBalanceAtom';
import CreditCoin from '../../icons/CreditCoin';
import Diamond from '../../icons/Diamond';
import { getProductFormattedNumber } from '../../helpers/CurrencyUtils';

export default function ConvertCatalogPackages({ packages, onClick }) {
  const diamondBalance = useRecoilValue(DiamondBalanceAtom);

  const isPurchasable = (p) => p && p.purchase && (diamondBalance >= p.purchase.price);

  return (
    <ul className="member-diamonds-to-credits">
      {packages.map((pack) => (
        <li key={pack.productId}>
          <div className="to-credits-coin-container">
            <div className="to-credits-coin">
              <CreditCoin />
            </div>

            <span>{getProductFormattedNumber(pack.exchange.price)}</span>
          </div>
          <div>
            <button
              className="btn btn-success btn-convert"
              type="button"
              onClick={() => { onClick(pack); }}
              disabled={!isPurchasable(pack)}
            >
              <div className="to-credits-diamond-wrapper">
                <div className="to-credits-diamond">
                  <Diamond />
                </div>
                <span>{getProductFormattedNumber(pack.purchase.price)}</span>
              </div>
            </button>
          </div>
        </li>
      ))}
    </ul>
  );
}
ConvertCatalogPackages.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  packages: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClick: PropTypes.func.isRequired,
};
